// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip-3RgpUc13LK9SuWE5PNzIC7","transition":"transition-3DDzyd7rqt4wuuInAqVhdv"};